module.exports = __webpack_public_path__ + "static/matt-turnbull-cartoon-240.f53e0f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matt-turnbull-cartoon-240.png
// module id = 137
// module chunks = 35783957827783 43363949817824